import { gql } from "@apollo/client";
import AsyncSelect from "react-select/async";
import client from "../apollo";
import { toast } from "react-toastify";
import { AppContext } from "../context";
import { useContext } from "react";

const FETCH_MERGE_CANDIDATES = gql`
  query FetchMergeCandidates(
    $page: Int!
    $limit: Int!
    $searchText: String
    $statusSearch: String
  ) {
    getMergeCandidates(
      payload: { page: $page, limit: $limit }
      filters: { searchText: $searchText, statusSearch: $statusSearch }
    ) {
      mergeCandidates {
        id
        destinationCandidateId
        destinationCandidateName
      }
    }
  }
`;

const AsyncMergeCandidates = (props) => {
  const { theme } = useContext(AppContext);
  const _filterCandidates = async (inputValue: string) => {
    try {
      const { data } = await client.query({
        query: FETCH_MERGE_CANDIDATES,
        variables: {
          limit: 50,
          page: 1,
          searchText: inputValue,
          statusSearch: null,
        },
      });

      return data && data.getMergeCandidates
        ? data?.getMergeCandidates?.mergeCandidates?.map((item) => ({
            value: item?.destinationCandidateId,
            label: item?.destinationCandidateName,
          }))
        : [];
    } catch (error) {
      toast.error("Error while loading merge candidates!");
    }
  };

  const promiseOptions = (inputValue: any): any =>
    new Promise((resolve) => {
      resolve(_filterCandidates(inputValue));
    });

  const customStyles = {
    control: (styles, provided) => ({
      ...styles,
      width: `${props.width} !important`,
      background: theme === "light" ? provided.background : "#282828",
      borderColor: theme === "light" ? "#ced4da" : "#282828",
      color: theme === "light" ? provided.background : "#d9d9d9",
      fontSize: 12,
      "&:hover": {
        borderColor: theme === "light" ? "#ced4da" : "#282828",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: theme === "light" ? provided.background : "#282828",
      zIndex: props?.zIndex || 999999,
      color: theme === "light" ? provided.background : "#d9d9d9",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: 12,
      background: theme === "light" ? provided.background : "#363636",
      "&:hover": {
        background: theme === "light" ? provided.background : "#474444",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <>
      <AsyncSelect
        cacheOptions
        isClearable
        ref={props.ref}
        styles={{ ...customStyles }}
        defaultOptions
        onChange={(selected: any) => {
          if (props.onSelected) {
            props.onSelected(selected?.value);
          }
          if (selected) {
            props.onChange(selected?.value);
          } else {
            props.onChange("");
          }
        }}
        loadOptions={promiseOptions}
        placeholder={props?.placeholder}
      />
    </>
  );
};

export default AsyncMergeCandidates;
